import { Popover } from 'element-ui'

const YPopover = Popover
YPopover.$depends = [Popover]
YPopover.$name = 'y-popover'
YPopover._name = 'Popover 弹出框'

export default YPopover
